import { useMemo } from 'react';
import { ViewMode } from '../models/preferences';
import {
  getFormatDateDayForDesktop,
  getFormatDateDayForMobile,
  getFormatDateMonth,
  getFormatDateWeek,
} from '../services/dateService';

interface UseDisplayDateArgs {
  viewMode: ViewMode;
  dateActivity: Date;
  isMobile: boolean;
}

export function useDisplayDate({
  viewMode,
  dateActivity,
  isMobile,
}: UseDisplayDateArgs): { displayDate: string } {
  const displayDate = useMemo(() => {
    switch (viewMode) {
      case ViewMode.DAY:
        if (isMobile) {
          return getFormatDateDayForMobile(dateActivity);
        }

        return getFormatDateDayForDesktop(dateActivity);
      case ViewMode.OLD_VIEW:
      case ViewMode.MONTH:
        return getFormatDateMonth(dateActivity);
      default:
        return getFormatDateWeek(dateActivity);
    }
  }, [viewMode, dateActivity, isMobile]);

  return { displayDate };
}
